<template>
    <div class="d-flex align-items-center" style="height:80px;padding-left:6%;padding-right:9%" id="header">
    	<header class="d-flex align-items-center justify-content-between width-p100" style="height:80px" >
    		<a href="#"  class="d-flex align-items-center">
    			<img src="https://image.xingqubaike.com:8443/minicard/ucenter/personcenter/login/logo.png" style="width:40px;height:40px" >
    			<div class="mar-left10 fz26 font-weight-bold">兴趣百科</div>
    		</a>
    		<div class="top-nav d-flex align-items-center" style="height:80px">

    			<a href="javascript:void(0)" v-on:click="toJump(1)" class="nav_a">首页</a>
    			<a href="javascript:void(0)" v-on:click="toJump(2)" class="nav_a" id="diaryList" style="height:100%;display: flex;align-items: center" >精选日记</a>
    			<a href="/#/shop" target="_blank" class="nav_a" id="shop" style="height:100%;display: flex;align-items: center">橙贝商城</a>
          <a href="https://www.xingqubaike.com/web" target="_blank">圈主后台</a>
          <!-- <router-link tag="a"
             target="_blank"
             :to="{ name: 'circleManager' }">圈主后台</router-link> -->
    		<!-- 	<a href="javascript:void(0)" v-on:click="toJump(4)" >圈主后台</a> -->
    		</div>
    	</header>
    </div>
</template>

<script>
  export default {
    mounted(){//页面加载后，调用接口数据

    },
    methods:{
      toJump:function(index){//跳转到哪个类目
        switch(index){
           case 1:
              this.$router.push({ name: 'HelloWorld',params:{}})//跳转到首页
              break;
           case 2:
                this.$router.push({ name: 'diaryList',params:{}})//跳转到精选日记
              break;
           case 3:
              this.$router.push({ name: 'shop'})//跳转到橙贝商城
              break;
        }

      },
    },
  }
</script>

<style lang="less">
  @import "../../../static/css/firstPage.css"; //直接在需要对应的vue中使用es6进行引入
</style>



// WEBPACK FOOTER //
// src/pages/pc/header.vue